import script from "./TradeOrderItemDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./TradeOrderItemDetail.vue?vue&type=script&setup=true&lang=ts"

import "./TradeOrderItemDetail.vue?vue&type=style&index=0&id=5864f90d&lang=scss&scoped=true"
import "./TradeOrderItemDetail.vue?vue&type=style&index=1&id=5864f90d&lang=scss"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5864f90d"]])

export default __exports__